export default __webpack_public_path__ + "static/media/perritos.d5eef182.png";